module.exports = __webpack_public_path__ + "img/royaume-uni.7ff5daca.png";